import {
  BrandAndMarketListItem,
  GuidIdCodeAndLabel,
  SSRV2RuleOrderValue,
} from "../../../../integrated-client";
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_TOTAL_ITEMS,
} from "../../../../utils/Constants";

export interface ISSRFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  carrier?: GuidIdCodeAndLabel;
  description?: string;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderByDescending?: boolean;
  orderValue?: SSRV2RuleOrderValue;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;
}

export class SSRFiltersData implements ISSRFiltersData {
  brandAndMarket?: BrandAndMarketListItem;
  carrier?: GuidIdCodeAndLabel;
  description?: string;
  showDeleted?: boolean;
  showDisabled?: boolean;
  orderByDescending?: boolean;
  orderValue?: SSRV2RuleOrderValue;
  offset: number;
  limit: number;
  total: number;
  currentPage: number;

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
    this.total = DEFAULT_TOTAL_ITEMS;
    this.currentPage = 1;
  }
}
